export const MAX_PAGE_CONTAINER_WIDTH = 'lg';
